import api from '../api/axios.config';

export const distributionService = {
  getData: async (page, page_size, view_type, columnFilters = {}, productFilters = {}) => {
    try {
      const params = { };

      if (page) params.page = page;
      if (page_size) params.page_size = page_size;
      if (view_type) params.view_type = view_type;

      Object.entries(columnFilters).forEach(([key, values]) => {
        if (values?.length) params[key] = values;
      });

      Object.entries(productFilters).forEach(([key, values]) => {
        if (values?.length) params[key] = values;
      });

      const response = await api.get(`/distribution`, { params });
      return response.data;
    }
    catch (error) {
      throw error;
    }
  },

  getBranchDetails: async (branch_name, page, page_size, columnFilters = {}) => {
    try {
      const params = { };

      if (page) params.page = page;
      if (page_size) params.page_size = page_size;
      if (branch_name) params.branch_name = branch_name;

      Object.entries(columnFilters).forEach(([key, values]) => {
        if (values?.length) params[key] = values;
      });

      const response = await api.get(`/distribution/details/`, { params });
      return response.data;
    }
    catch (error) {
      throw error;
    }
  },

  getDistributionSummary: async () => {
    try {
      const response = await api.get(`/distribution/summary/`);
      return response.data;
    }
    catch (error) {
      throw error;
    }
  },

  getSummaryInformationIcon: async () => {
    try {
      const response = await api.get(`/distribution/summary/information-icon`);
      return response.data;
    }
    catch (error) {
      throw error;
    }
  },

  getBranchSummaryInformationIcon: async (branch_name) => {
    try {
      const response = await api.get(`/distribution/details/summary/information-icon/`, { params: { branch_name } });
      return response.data;
    } catch(error) {
      throw error;
    }
  },

  getReadinessInfoIcon: async () => {
    try {
      const response = await api.get(`/distribution/details/readiness-for-target-per-sku-information-icon/`);
      return response.data;
    } catch(error) {
      throw error;
    }
  },

  getBranchDistributionSummary: async (branch_name) => {
    try {
      const params = { };

      if (branch_name) params.branch_name = branch_name;
      const response = await api.get(`/distribution/details/summary/`, { params });
      return response.data;
    } 
    catch (error) {
      throw error;
    }
  },
  
  updateAdjustedQty: async (branch_name, adjusted_amount_kzt_per_branch) => {
    try{
      const response = await api.patch(
          `/distribution/`,
          {
            updates: [
              {
                branch_name,
                adjusted_amount_kzt_per_branch
              },
            ],
          },
      );
  
      return response.data;
    }
    catch(error){
      throw error
    }
  },

  updateBranchAdjustedQty: async (branch_name, sku_code, adjusted_quantity_in_mc) => {
    try{
      const response = await api.patch(
          `/distribution/details/?branch_name=${branch_name}`,
          {
            updates: [
              {
                sku_code,
                adjusted_quantity_in_mc
              },
            ],
          },
      );
  
      return response.data;
    }
    catch(error){
      throw error
    }
  },

  downloadExcel: async(page, page_size, view_type, columnFilters = {}, productFilters = {}) => {
    try{
  
      const params = { };

      if (page) params.page = page;
      if (page_size) params.page_size = page_size;
      if (view_type) params.view_type = view_type;

      Object.entries(columnFilters).forEach(([key, values]) => {
        if (values?.length) params[key] = values;
      });

      Object.entries(productFilters).forEach(([key, values]) => {
        if (values?.length) params[key] = values;
      });

      const response = await api.get(`/distribution/download`, 
        { 
          responseType: "blob",
          params
        });
  
      return response;
    }catch(error){
      throw error
    }
  },

  branchDownloadExcel: async(branch_name) => {
    try{
  
      const response = await api.get(`/distribution/details/download?branch_name=${branch_name}`, 
        { 
          responseType: "blob",
        });
  
      return response;
    }catch(error){
      throw error
    }
  },
  
};
